/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ChimePlus = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.6326 2.25H13.3674L15.3922 8.60779L21.75 10.6326V13.3674L15.3922 15.3922L13.3674 21.75H10.6326L8.60779 15.3922L2.25 13.3674V10.6326L8.60779 8.60779L10.6326 2.25ZM12 3.75C11.8387 3.75 11.6959 3.85437 11.6469 4.00808L9.80177 9.80177L4.00808 11.6469C3.85437 11.6959 3.75 11.8387 3.75 12C3.75 12.1613 3.85437 12.3041 4.00808 12.3531L9.80177 14.1982L11.6469 19.9919C11.6959 20.1456 11.8387 20.25 12 20.25C12.1613 20.25 12.3041 20.1456 12.3531 19.9919L14.1982 14.1982L19.9919 12.3531C20.1456 12.3041 20.25 12.1613 20.25 12C20.25 11.8387 20.1456 11.6959 19.9919 11.6469L14.1982 9.80177L12.3531 4.00808C12.3041 3.85437 12.1613 3.75 12 3.75Z"
                        fill={color}
                    />
                </svg>
        );
    };
